import loadable from '@loadable/component';

export const CmsRecommendedJobsBlockLoadable = loadable(
  () => import('./CmsRecommendedJobsBlock'),
  { resolveComponent: (module) => module.CmsRecommendedJobsBlock },
);
